<template>
	<v-flex >
		<v-layout row class="body-2 ml-4 mt-4 mb-2 caption">
			<v-flex xs2 class="pb-1 pl-2 mr-2 ">
			  	Code
			</v-flex>
			<v-flex xs8 class="pb-1 pl-2 mr-2 ">
				Description
			</v-flex>
			<v-flex xs1 class="pb-1 pl-2 mr-2   ">
				PCT
			</v-flex>
			<v-flex xs1 class="pb-1 px-2"></v-flex>				
				
		</v-layout>
		<v-divider></v-divider>
		<v-list class="programList ml-2 mt-3" dense >

			<v-list-tile v-if="room" v-for="(item, index) in programs" 
				:key="index"
				class="programListTile">
				
				<v-layout row>
					<v-flex xs2 class="mr-2">						
					  	<v-text-field 
					  		class="body-1"                         
	                        v-model="item.programID"
	                        label="Program Code"
	                        single-line  
	                        readonly 
	                        flat solo   
	                        hide-details                    
	                        @change="changed=true">                   
	                    </v-text-field>
					</v-flex>
					<v-flex xs8 class="mr-2">
						<v-autocomplete
							:items="programlist"
							@input="changed=true"
							item-text="nameAndID"
							item-value="programID"
							v-model="item.programID"
							cache-items
							class="body-1"
							flat solo
							single-line
							hide-no-data
							hide-details
							label="Program"							
						></v-autocomplete>
					</v-flex>
					<v-flex xs1 class="mr-2">
						<v-text-field 
							reverse
							class="body-1"        
	                        v-model="item.percentage"
	                        label="Program Code"
	                        single-line  
	                        flat solo  
	                        hide-details                      
	                        @change="changed=true">                  
	                    </v-text-field>
					</v-flex>

					<v-flex xs1 class="px-2 text-xs-right" style="margin-top: 10px !important;">
						<v-tooltip top>		              				                
			                <v-icon small slot="activator" @click="deleteProgram(index)" color="red lighten-2">close</v-icon>          
				            <span>Delete</span>
			            </v-tooltip>
					</v-flex>


				</v-layout>
			</v-list-tile>
		</v-list>
		
		<v-layout row class="ml-3">
			<v-tooltip v-if="unsaved" top>
				<v-btn slot="activator" @click="cancel" icon><v-icon color="grey darken-3">cancel</v-icon></v-btn>
				<span>Cancel</span>
			</v-tooltip>
			<v-tooltip v-if="unsaved" top>
				<v-btn slot="activator" @click="save" icon><v-icon color="grey darken-3">save</v-icon></v-btn>
				<span>Save</span>
			</v-tooltip>
		</v-layout>

	</v-flex>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
data () {
	return {	changed: false,		}
},

computed: {
	...mapState({   	room:  				state => state.dv.room,
						deptSelectedIndex: 	state => state.dv.deptSelectedIndex,
						programlist:   		state => state.lists.programs,
				}),

	programs: function () {
		return this.room ? this.room.PCT[this.deptSelectedIndex].program : []
	},
	
	unsaved: function() {
		if (this.room) {
			return this.room.PCT[this.deptSelectedIndex].program.find((program) => !program.key || this.changed ) ? true : false
		} else {
			return false
		}
	}

},

methods : {
	...mapMutations([ 'addBlankProgramRow', 'setLoadingRoomDetail', 'setSnackText']),
	...mapActions([	'updateProgram', 'fetchFullRoom', 'setRoom']),

	deleteProgram: function (index) {
		this.programs.splice(index, 1) // Remove from local memory
		this.changed=true
	},

	cancel: function () {
		this.setLoadingRoomDetail(true)
		this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => {
				this.setLoadingRoomDetail(false)
				this.changed = false
				this.setRoom(data)
			})
	},

	save: function () {		

		let sum = 0
		let exit = false
		this.programs.forEach((row, index) => { 
			if (row['percentage'] == 0) {
	        	this.setSnackText('Percentage 0 no allowed.  Use Delete.')
	        	exit = true		
			}

			sum += parseInt(row['percentage']) 
		})

		if (exit) { return }

		if (sum != 100) {
			console.log("Sum: ", sum)
	        this.setSnackText('Percentages must add to 100')
	        return 
		}

		const payload = { rmpctKey: this.room.PCT[this.deptSelectedIndex].key, programArray: this.programs }
		this.setLoadingRoomDetail(true)
		this.updateProgram(payload).then((response) => {
			this.changed = false
			this.setLoadingRoomDetail(false)
	        if (response != "Saved") { this.setSnackText(response) }
			this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => this.setRoom(data) )
		})		
	},
},

}
</script>

<style>

.programHeader {
	border-width: 1px !important;
	border-bottom: solid;
	border-color: black;
}

.programList {
	height: 256px;
	overflow: auto;
}

.programListTile > .v-list__tile {
	height: 11px !important;
	padding-left: px;
	margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomDetailPrograms.vue